import React from "react";
import "./assets/scss/style.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { MintingProgressProvider } from "./context/stateManager";
import { ChainId, ThirdwebProvider } from "@thirdweb-dev/react";

function App() {
  return (
    <ThirdwebProvider 
    desiredChainId={ChainId.Goerli}
    authConfig={{
      authUrl: "/api/auth",
      domain: "example.com",
    }}
  >
      <MintingProgressProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </MintingProgressProvider>
    </ThirdwebProvider>
  );
}

export default App;
